var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAmbulance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_883_8113)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2832 6.21369L17.8191 4.102C17.9217 3.69762 18.2857 3.41444 18.7029 3.41444H21.3824C21.7996 3.41444 22.1636 3.69756 22.2662 4.102L22.8021 6.21369L20.0427 6.83869L17.2832 6.21369Z",
    fill: "#FB5360"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4102 6.76844V8.458L20.0416 9.083L23.673 8.458V6.76844C23.673 6.46206 23.4247 6.21369 23.1183 6.21369H16.9648C16.6585 6.21369 16.4102 6.46206 16.4102 6.76844Z",
    fill: "#0070A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 17.6684C32 16.6336 31.1612 15.7948 30.1264 15.7948H29.2738L27.1731 13.598L27.5723 11.4012L26.9211 9.7195C26.6266 8.95912 25.8951 8.458 25.0798 8.458H14.7509L8.80931 9.083L2.86775 8.458H1.54756C0.692875 8.458 0 9.15088 0 10.0056V23.5977L17.2823 25.4727L32 23.5977V21.0558L31.375 19.6963L32 18.3367V17.6684Z",
    fill: "#99DFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0008 17.6684C32.0008 16.6336 31.162 15.7948 30.1272 15.7948H29.2746L28.0493 13.7606L27.5731 11.4011L26.9218 9.71944C26.6274 8.95906 25.8958 8.45794 25.0805 8.45794H23.2754C24.0908 8.45794 24.8223 8.95912 25.1167 9.71944L28.0489 16.7606H28.6277C29.6003 16.7606 30.3888 17.5491 30.3888 18.5217V24.2227L32.0007 23.5977V21.0559L31.3757 19.8171L32.0007 18.3367V17.6684H32.0008Z",
    fill: "#1FB8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 23.5977V25.1117C0 25.7357 0.50575 26.2414 1.12969 26.2414H30.8703C31.4942 26.2414 32 25.7357 32 25.1117V23.5977H0Z",
    fill: "#FB5360"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3875 25.1118C30.3875 25.7358 29.8817 26.2415 29.2578 26.2415H30.8697C31.2207 26.2415 31.5342 26.0815 31.7415 25.8304C31.8566 25.6909 31.9389 25.5233 31.9765 25.3394C31.9916 25.2659 31.9994 25.1897 31.9994 25.1117V23.5977H30.3875V25.1118Z",
    fill: "#CD5668"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7503 8.458H2.86719V19.0047C2.86719 19.3604 3.15544 19.6486 3.51106 19.6486H14.1065C14.4621 19.6486 14.7504 19.3604 14.7504 19.0047V8.458H14.7503Z",
    fill: "#219AFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1043 27.5478C11.4848 26.1673 11.4848 23.9291 10.1043 22.5486C8.72377 21.1681 6.48556 21.1681 5.10507 22.5486C3.72458 23.9291 3.72458 26.1673 5.10507 27.5478C6.48556 28.9282 8.72378 28.9283 10.1043 27.5478Z",
    fill: "#0070A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.79354 26.2252C8.443 26.1199 8.88414 25.508 8.77886 24.8586C8.67357 24.2091 8.06174 23.768 7.41228 23.8733C6.76282 23.9785 6.32168 24.5904 6.42696 25.2398C6.53224 25.8893 7.14408 26.3304 7.79354 26.2252Z",
    fill: "#C2ECFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9148 27.5495C28.2953 26.169 28.2953 23.9308 26.9148 22.5503C25.5343 21.1698 23.2961 21.1698 21.9156 22.5503C20.5351 23.9308 20.5351 26.169 21.9156 27.5495C23.2961 28.93 25.5343 28.93 26.9148 27.5495Z",
    fill: "#0070A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6041 26.2282C25.2535 26.1229 25.6947 25.5111 25.5894 24.8616C25.4841 24.2122 24.8723 23.771 24.2228 23.8763C23.5734 23.9816 23.1322 24.5934 23.2375 25.2429C23.3428 25.8923 23.9546 26.3335 24.6041 26.2282Z",
    fill: "#C2ECFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3436 21.0558H31.9993V18.3367H29.3436C29.0298 18.3367 28.7754 18.5911 28.7754 18.905V20.4876C28.7753 20.8014 29.0298 21.0558 29.3436 21.0558Z",
    fill: "#FFA95F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3887 18.5217V21.0558H32.0006V18.3367H30.3789C30.3853 18.3975 30.3887 18.4592 30.3887 18.5217Z",
    fill: "#FF8B5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.572 11.4012H23.1227C22.9449 11.4012 22.8008 11.5453 22.8008 11.7231V15.4729C22.8008 15.6507 22.9449 15.7949 23.1227 15.7949H29.2735L27.572 11.4012Z",
    fill: "#0070A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6461 15.7948H29.274L27.5725 11.4012H25.8164L27.6461 15.7948Z",
    fill: "#44576A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7553 12.9802H10.0035C9.93664 12.9802 9.88239 12.9259 9.88239 12.8591V11.1073C9.88239 11.007 9.80108 10.9257 9.70077 10.9257H7.91783C7.81752 10.9257 7.7362 11.007 7.7362 11.1073V12.8591C7.7362 12.9259 7.68195 12.9802 7.61508 12.9802H5.86327C5.76295 12.9802 5.68164 13.0615 5.68164 13.1618V14.9447C5.68164 15.0451 5.76295 15.1264 5.86327 15.1264H7.61502C7.68189 15.1264 7.73614 15.1806 7.73614 15.2475V16.9992C7.73614 17.0996 7.81745 17.1809 7.91777 17.1809H9.7007C9.80102 17.1809 9.88233 17.0996 9.88233 16.9992V15.2475C9.88233 15.1806 9.93658 15.1264 10.0035 15.1264H11.7552C11.8555 15.1264 11.9368 15.0451 11.9368 14.9447V13.1618C11.9369 13.0615 11.8556 12.9802 11.7553 12.9802Z",
    fill: "#C2ECFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_883_8113"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmbulance);
export default __webpack_public_path__ + "static/media/ambulance.34a18cd7a2168341f06ac33fe7051025.svg";
export { ForwardRef as ReactComponent };